import { ApplicationRoutes } from '~/hooks/useRouting'

export const isNavRouteSelected = (pathname: string, route: string) => {
  if (route === ApplicationRoutes.CALLS && pathname === '/') {
    return true
  }
  const normalizedRoute = route.startsWith('/') ? route : `/${route}`
  return (
    pathname === normalizedRoute || pathname.startsWith(`${normalizedRoute}/`)
  )
}
